import {cancel, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterGpio extends BridgeMethod {

  readGpio(path) {
    return invoke("readGpio", {params: {path}});
  }

  /**
   *
   * @param path 路径
   * @param value{number} 设置的值
   * @return {Promise<Object>}
   */
  writeGpio(path, value) {
    return invoke("writeGpio", {params: {path, value}});
  }

  /**
   *
   * @param callback {function({x,y,z,timestamp})}
   * @return {Promise<{cancel: Function}>}
   */
  onGpioValueChange(callback) {
    return on("onGpioValueChange", callback, {isSend: true});
  }

  offGpioValueChange(callback) {
    return cancel("onGpioValueChange", {event: callback, isSend: true});
  }

  startGpioListen(paths, time = 10) {
    return invoke("startGpioListen", {params: {paths, time}});
  }

  stopGpioListen(paths) {
    return invoke("stopGpioListen", {params: {paths}});
  }
}

export const flutterGpio = new FlutterGpio();